import { email, required } from "utils/validate.util";
import InputRedux from "components/molecules/InputRedux";
import { ReduxFormField } from "components/molecules/ReduxFormFields";
import CheckboxRedux from "components/molecules/CheckboxRedux";

export { default } from "./AddQuotationForm";

export const fields: ReduxFormField[] = [
  // {
  //   name: "language",
  //   label: "English",
  //   component: CheckboxRedux,
  //   cellProps: { lg: 12 },
  // },
  {
    name: "company_name",
    label: "Company Name",
    validate: [required],
    component: InputRedux,
    cellProps: { lg: 4 },
  },
  {
    name: "person_name",
    label: "Person Name",
    validate: [required],
    component: InputRedux,
    cellProps: { lg: 4 },
  },
  {
    name: "company_email",
    label: "Email",
    validate: [required, email],
    component: InputRedux,
    InputProps: {
      type: "email",
    },
    cellProps: { lg: 4 },
  },

  {
    name: "company_address",
    label: "Address 1",
    component: InputRedux,
    cellProps: { lg: 12 },
  },
  {
    name: "company_address2",
    label: "Address 2",
    component: InputRedux,
    cellProps: { lg: 12 },
  },
  {
    name: "title",
    label: "Title or Salutation:",

    component: InputRedux,
    cellProps: { lg: 12 },
  },
  {
    name: "message",
    label: "Message",
    InputProps: {
      multiline: true,
    },
    component: InputRedux,
    cellProps: { lg: 12 },
  },
];
